import React, { useState } from 'react';
import { Section } from './ui/Section';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  q: '¿Necesito Notion, herramientas raras o diseño?',
  a: 'No. Puedes hacerlo con una página simple y texto claro.'
}, {
  q: '¿Y si no tengo audiencia?',
  a: 'Este embudo está diseñado para empezar con tráfico pequeño también. La prioridad es tener la ruta lista.'
}, {
  q: '¿En cuánto tiempo lo implemento?',
  a: 'Puedes publicarlo en una tarde si sigues la checklist.'
}, {
  q: '¿Qué pasa si me bloqueo?',
  a: 'El método está hecho para destrabar: si te atoras, vuelves al titular y a los entregables.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <Section className="bg-primary" data-id="element-23">
      <h2 className="text-3xl md:text-4xl font-bold text-white text-center mb-12" data-id="element-24">
        Preguntas frecuentes
      </h2>

      <div className="max-w-2xl mx-auto space-y-4" data-id="element-25">
        {faqs.map((faq, i) => <div key={i} className="border border-white/10 rounded-lg overflow-hidden bg-section" data-id="element-26">
            <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className="w-full flex items-center justify-between p-6 text-left hover:bg-white/5 transition-colors" data-id="element-27">
              <span className="font-medium text-white text-lg" data-id="element-28">{faq.q}</span>
              <ChevronDown className={`w-5 h-5 text-text-muted transition-transform duration-300 ${openIndex === i ? 'rotate-180' : ''}`} data-id="element-29" />
            </button>
            <AnimatePresence data-id="element-30">
              {openIndex === i && <motion.div initial={{
            height: 0,
            opacity: 0
          }} animate={{
            height: 'auto',
            opacity: 1
          }} exit={{
            height: 0,
            opacity: 0
          }} transition={{
            duration: 0.3
          }} data-id="element-31">
                  <div className="p-6 pt-0 text-text-secondary border-t border-white/5" data-id="element-32">
                    {faq.a}
                  </div>
                </motion.div>}
            </AnimatePresence>
          </div>)}
      </div>
    </Section>;
}